import { CommercialisationTask } from "@ac-expo/api-types";
import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../axiosInstances";
import { commercialisationTasksQueryKeys } from "../query-keys";

const getCommercialisationTasks = async () => {
  const res = await privateAxios.get<CommercialisationTask[]>("/tasks");
  return res.data;
};

export const useGetCommercialisationTasks = () => {
  return useQuery({
    queryKey: commercialisationTasksQueryKeys.all,
    queryFn: () => getCommercialisationTasks(),
  });
};

const getCommercialisationTaskById = async (id: string) => {
  const res = await privateAxios.get<CommercialisationTask>(`/tasks/${id}`);
  return res.data;
};

export const useGetCommercialisationTaskById = (id: string) => {
  return useQuery({
    queryKey: commercialisationTasksQueryKeys.byId(id),
    queryFn: () => getCommercialisationTaskById(id),
  });
};
